// extracted by mini-css-extract-plugin
export default {"result":"SolarisCalculatorResult_result__tKb3U"};